// extracted by mini-css-extract-plugin
module.exports = {"title":"References-module--title--3JvM9","grid":"References-module--grid--1P_P7","divider":"References-module--divider--P7yY_"};